import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserLoggedIn } from './../../../sharedFeatures/models/user-login.model';
import { BaseHttpServiceService } from './../../../sharedFeatures/services/base-http-service.service';
import { CurrentUserService } from './../../../sharedFeatures/services/current-user.service';
import { Login } from '../models/login';
import { ExchangeToken } from '../models/exchangeToken';
@Injectable({
  providedIn: 'root',
})
export class LoginService extends BaseHttpServiceService {
  //private controller: string = `${this.baseUrl}/Users/user-login`;
  // baseURL=environment.APIUrl;
  constructor(
    http: HttpClient,
    translateService: TranslateService,
    currentUserService: CurrentUserService
  ) {
    super(http, translateService, currentUserService);
  }

  login(item: Login): Observable<UserLoggedIn> {
    // Use publicAuthUrl - doesn't require subscription key
    let url: string = `${this.publicAuthUrl}/User/Login`;

    return this.postData<UserLoggedIn>(url, item);
  }

  /**
   * Re-authenticate user with selected module and role to get updated token
   * This matches the MVC AccountController.loginUserWithModule logic
   */
  loginWithModuleAndRole(
    userName: string,
    password: string,
    moduleId: number,
    roleId?: number
  ): Observable<UserLoggedIn> {
    // Use publicAuthUrl - doesn't require subscription key
    let url: string = `${this.publicAuthUrl}/User/LoginWeb`;

    // Add roleId as query parameter if provided
    if (roleId) {
      url += `?roleId=${roleId}`;
    }

    const requestBody = {
      userName: userName,
      password: password,
      moduleId: moduleId,
      fromActiveDirectory: false,
    };

    // LoginWeb returns wrapped response: { isSuccess: bool, data: UserLoggedIn }
    return this.postData<any>(url, requestBody).pipe(
      map((response: any) => {
        // Check if response is wrapped in APIResult structure
        if (response && response.isSuccess && response.data) {
          return response.data as UserLoggedIn;
        }
        // If not wrapped, return as is
        return response as UserLoggedIn;
      })
    );
  }

  forgetPassword(email: string): Observable<string> {
    // Use publicAuthUrl - doesn't require subscription key
    let url: string = `${this.publicAuthUrl}/User/ForgotPasswordWeb?Email=${email}`;

    return this.getTextData(url);
  }
  exchangeToken(item: ExchangeToken): Observable<UserLoggedIn> {
    let url: string = `${this.mysteryShopperUrl}/User/ExchangeToken`;

    return this.postData<UserLoggedIn>(url, item);
  }

  /**
   * Get Azure AD login configuration data
   */
  getAzureLoginData(): Observable<any> {
    let url: string = `${this.mysteryShopperUrl}/User/GetLoginData`;

    return this.getData<any>(url);
  }

  /**
   * Login with Microsoft authorization code
   */
  loginWithMicrosoft(
    code: string,
    returnUrl?: string
  ): Observable<UserLoggedIn> {
    let url: string = `${this.mysteryShopperUrl}/User/LoginWithMicrosoft?code=${encodeURIComponent(code)}`;
    if (returnUrl) {
      url += `&returnUrl=${encodeURIComponent(returnUrl)}`;
    }

    return this.getData<any>(url).pipe(
      map((response: any) => {
        // Handle wrapped response format
        if (response && response.isSuccess && response.data) {
          return response.data as UserLoggedIn;
        }
        // If not wrapped, return as is
        return response as UserLoggedIn;
      })
    );
  }

  /**
   * Logout user and revoke tokens
   * SECURITY FIX: VAPT Issue #3 - Iteration 1
   * @param refreshToken Optional refresh token to revoke
   * @param logoutAllDevices Whether to logout from all devices or just current
   */
  logout(
    refreshToken?: string,
    logoutAllDevices: boolean = false
  ): Observable<any> {
    let url: string = `${this.mysteryShopperUrl}/oAuth/Logout`;

    return this.postData(url, { refreshToken, logoutAllDevices });
  }

  /**
   * Refresh access token using refresh token
   * SECURITY FIX: VAPT Issue #3 - Iteration 1
   * @param refreshToken The refresh token to use
   * @returns Observable with new access token and refresh token
   */
  refreshToken(
    refreshToken: string
  ): Observable<{ accessToken: string; refreshToken: string }> {
    let url: string = `${this.mysteryShopperUrl}/oAuth/RefreshToken`;

    return this.postData<{ accessToken: string; refreshToken: string }>(url, {
      refreshToken,
    });
  }
}
